import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from '../shared/http/http-request.service';
import { HttpRequestOptions } from '../shared/http/http-request-options.model';
import { AuthService } from '../shared/auth/auth.service';
import { ApiService } from '../shared/api/api.service';
import { UtilService } from '../shared/util/util.service';

@Component({
  selector: 'wl-initial-test',
  templateUrl: 'initial-test.component.html',
  providers: [HttpRequestService, AuthService, ApiService, UtilService],
    standalone: false
})
export class InitialTestComponent implements OnInit {
  private _httpRequestService: HttpRequestService;
  private _authService: AuthService;
  private _apiService: ApiService;
  private _utilService: UtilService;

  public output: string;
  public startDate: Date;

  public constructor(httpRequestService: HttpRequestService, authService: AuthService, apiService: ApiService, utilService: UtilService) {
    this._httpRequestService = httpRequestService;
    this._authService = authService;
    this._apiService = apiService;
    this.startDate = new Date(2019, 1, 17);
    this._utilService = utilService;
  }

  public ngOnInit(): void {}
  public selectedDateChange() {
    this.output = this.startDate.toString();
  }
  public getData = (): void => {
    let url: string = 'https://wlfoshizzle.com/api/test/getlisttest';
    this._httpRequestService.getRequest(url, new HttpRequestOptions()).then((data: any) => {
      this.output = JSON.stringify(data);
    });
  };
  public getAuth = (): void => {
    this._authService.sendUserToAuthServerLogin('jondevqanhcoc');
  };

  public getApi = (verb: string): void => {
    this.output = '';
    let url: string = 'https://wlfoshizzle.com/api/test/';

    switch (verb.toLowerCase()) {
      case 'get': {
        url = url + 'getlisttest';
        this._apiService.get(url).then((data: any) => {
          this.output = JSON.stringify(data);
        });
        break;
      }
      case 'post': {
        url = url + 'posttest';
        this._apiService.post(url, null).then((data: any) => {
          this.output = JSON.stringify(data);
        });
        break;
      }
      case 'put': {
        url = url + 'puttest';
        this._apiService.put(url, null).then((data: any) => {
          this.output = JSON.stringify(data);
        });
        break;
      }
      case 'delete': {
        url = url + 'deletetest';
        this._apiService.delete(url).then((data: any) => {
          this.output = JSON.stringify(data);
        });
        break;
      }
      default: {
        //statements;
        break;
      }
    }
    //"
  };

  public GetRandomText = (): void => {
    var value = this._utilService.getRandomText(5);
    this.output = value;
  };

  public GetRandomText2 = (): void => {
    var value = this._utilService.getRandomText(2);
    this.output = value;
  };

  public GetRandomText3 = (): void => {
    var value = this._utilService.getRandomText(4);
    this.output = value;
  };
}
